import { LinearProgress } from '@mui/material';

import { ILoading } from '../Login';
import { LoginButton } from '../styles';

import { Container } from './styles';

interface Props {
  loading: ILoading;
}

const LoginWithReCaptcha = ({ loading }: Props) => {
  return (
    <Container loading={loading.is.toString()}>
      <LoginButton type="submit">{loading.is ? 'Carregando...' : 'Entrar'}</LoginButton>
      <LinearProgress id="linear-progress" color="primary" />
    </Container>
  );
};

export default LoginWithReCaptcha;
